<template>
  <div>
    <div class="add-image-from-url">
      <div @click="isShowFromURL = true">Add image from URL</div>
    </div>
    <div class="container-upload" :style="{ minHeight: height + 'px' }">
      <div v-if="isLoading" class="loading-upload">
        <v-progress-circular indeterminate color="primary" />
      </div>
      <div v-else-if="!image || !image.imageSrc" class="placeholder-upload" @click="uploadFile">
        <div class="text-center">
          <v-icon>mdi-upload</v-icon>
          <p>Upload image here</p>
          <input
            style="display: none"
            class="hidden"
            type="file"
            ref="inputImage"
            accept="image/gif, image/jpeg, image/png , image/jpg, image/webp, video/mp4, video/webm, video/ogg"
            @change="onChangeImage"
          />
        </div>
      </div>

      <div v-else-if="image && image.imageSrc && typeUpload == 'image'" class="image-upload">
        <img class="image-upload-item" :src="imageHelpers.relativeUrl(image.imageSrc)" alt="" />
        <div class="action-upload">
          <v-btn icon @click="isShowImage = true">
            <v-icon size="20">mdi-eye</v-icon>
          </v-btn>
          <v-btn icon @click="removeUpload">
            <v-icon size="20">mdi-delete</v-icon>
          </v-btn>
        </div>
      </div>
      <v-dialog v-model="isShowImage" max-width="900">
        <v-card>
          <div class="d-flex justify-center">
            <img loading="eager" :src="imageHelpers.relativeUrl(image.imageSrc)" alt="" />
          </div>
        </v-card>
      </v-dialog>
    </div>
    <v-dialog v-model="isShowFromURL" max-width="900">
      <v-card>
        <v-card-title>Add image from URL</v-card-title>
        <v-card-text>
          <v-text-field v-model="urlImage" label="URL" />
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
          <v-btn text color="primary" @click="isShowFromURL = false">Cancel</v-btn>
          <v-btn text color="primary" @click="onAddImageFromURL">Add Image</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { uploadService } from '@/apis/upload.s';
import axios from 'axios';
import imageHelpers from '@/helpers/image';
import './upload-image.scss';
export default {
  props: {
    subTitle: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: 'Image',
    },
    typeUpload: {
      type: String,
      default: 'image',
    },
    image: {
      type: Object,
      default: () => {},
    },
    itemSetData: {
      type: Object,
      default: () => {},
    },
    height: {
      type: String,
      default: '350',
    },
    width: {
      type: String,
      default: '300',
    },
    resize: {
      type: Object,
      default: () => ({ width: 1000, height: 1000 }),
    },
  },
  data() {
    return {
      isLoading: false,
      isShowImage: false,
      imageHelpers: imageHelpers,
      isShowFromURL: false,
      urlImage: '',
    };
  },
  methods: {
    optimizeImageSrc(rawSrc) {
      const src = (rawSrc || '').trim();
      if (!src) return src;

      const isDev = process.env.NODE_ENV === 'development';
      if (isDev) return src;

      try {
        const url = new URL(src, window.location.origin);
        const match = url.pathname.match(/\/images\/(.+)/);
        if (!match) return src;

        let optimizedSrc = `/uploads/images/${match[1]}`;

        if (url.searchParams.has('q')) {
          optimizedSrc += `?w=${this.widthParam}&q=${this.qualityParam}`;
        }

        return optimizedSrc;
      } catch (e) {
        return src;
      }
    },
    onAddImageFromURL() {
      const rawUrl = (this.urlImage || '').trim();
      if (!rawUrl) {
        this.isShowFromURL = false;
        this.urlImage = '';
        return;
      }

      this.$emit(
        'callback',
        {
          alt: rawUrl,
          alt_text: rawUrl,
          imageSrc: rawUrl,
          _id: this.objectId(),
        },
        this.itemSetData,
        'image',
      );
      this.isShowFromURL = false;
      this.urlImage = '';
    },
    async onChangeImage(e) {
      let size = { width: 0, height: 0 };
      var _URL = window.URL || window.webkitURL;
      let img = new Image();
      let file = e.target.files[0];
      // Check file size (10MB = 10 * 1024 * 1024)
      if (file.size > 100 * 1024 * 1024) {
        this.$store.dispatch('setMessage', { messages: 'File must be less than 100MB!', type: 'error' });
        return false;
      }
      img.onload = function() {
        size.width = this.width;
        size.height = this.height;
      };
      img.src = _URL.createObjectURL(file);
      try {
        let type = file.name.split('.')[file.name.split('.').length - 1];
        let id = this.objectId();
        this.isLoading = true;
        let urlData = await uploadService.get({ filename: `image-${id}.${type}` });
        if (urlData) {
          let res = await axios.put(urlData.data.presignedUrl, file, {
            headers: {
              'Content-Type': `${file.type}`,
            },
          });

          let obj = {
            alt: file.name,
            alt_text: file.name,
            imageSrc: imageHelpers.relativeUrl(urlData.data.imagePath, this.resize),
            _id: id,
            size: size,
          };
          this.$emit('callback', obj, this.itemSetData);
        }
      } catch (e) {
        console.log(e);
        this.$store.commit('setMessages', {
          messages: 'Error image ',
          type: 'error',
        });
      } finally {
        this.isLoading = false;
      }
    },
    objectId() {
      return this.hex(Date.now() / 1000) + ' '.repeat(16).replace(/./g, () => this.hex(Math.random() * 16));
    },
    removeUpload() {
      // giống onChangeImage()
      if (this.typeUpload === 'image') {
        this.$emit('callbackDelete', this.itemSetData, 'image');
      } else {
        this.$emit('callbackDelete', this.itemSetData, '');
      }
    },
    hex(value) {
      return Math.floor(value).toString(16);
    },
    uploadFile() {
      this.$refs.inputImage.click();
    },
  },
  watch: {},
};
</script>

<style>
.add-image-from-url {
  color: #0081c7;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 5px;
  > div {
    cursor: pointer;
  }
}
</style>
